import axios from 'axios';

const DEFAULT_FIELD = 'id,name,treePath,version,isUsed,categoryCode,courseTypeCode';
async function getTextbook({ textbookId, fields = DEFAULT_FIELD }) {
	return axios.get(`/api/textbooks/${textbookId}`, {
		params: {
			fields
		}
	});
}

async function getTextbookChildren({ textbookId, fields = DEFAULT_FIELD }) {
	return axios.get(`/api/textbooks/${textbookId}/child`, {
		params: {
			fields
		}
	});
}

async function getTextbookParent({ textbookId, fields = DEFAULT_FIELD }) {
	return axios.get(`/api/textbooks/${textbookId}/parent`, {
		params: {
			fields
		}
	});
}

async function getTextbookSeries({ courseTypeCode, categoryCode, fields = DEFAULT_FIELD }) {
	return axios.get('/api/textbooks/series', {
		params: {
			courseTypeCode,
			categoryCode,
			fields
		}
	});
}

async function getTextbookCategoryTree() {
	return axios.get('/api/textbooks/category/tree');
}



export {
	getTextbook,
	getTextbookChildren,
	getTextbookParent,
	getTextbookSeries,
	getTextbookCategoryTree
};